import { Link } from "react-router-dom";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export type PropsType = {
    icon?: JSX.Element;
    titleIcon?: string;
    icon2?: JSX.Element;
    titleIcon2?: string;
    iconRight?: JSX.Element;
    text?: string | JSX.Element;
    link?: string;
    onClick?: CallableFunction;
    onIconClick?: () => void;
    onIcon2Click?: () => void;
    onTextClick?: CallableFunction;
    hoverable?: boolean;
    disabled?: boolean;
};

function IconText({
    icon,
    titleIcon,
    icon2,
    titleIcon2,
    iconRight,
    text,
    link,
    onClick,
    onIconClick,
    onIcon2Click,
    onTextClick,
    hoverable,
    disabled,
}: PropsType) {
    const content = (
        <>
            {onIconClick && !disabled ? (
                <button
                    type={"button"}
                    data-testid={"icon-1"}
                    title={titleIcon}
                    className={"icon-container"}
                    onClick={onIconClick}
                >
                    {icon}
                </button>
            ) : (
                <div data-testid={"icon-1"} className={"icon-container"}>
                    {icon}
                </div>
            )}

            {icon2 &&
                (onIcon2Click && !disabled ? (
                    <button
                        type={"button"}
                        className={"icon-container icon-2"}
                        title={titleIcon2}
                        onClick={onIcon2Click}
                    >
                        {icon2}
                    </button>
                ) : (
                    <div className={"icon-container icon-2"}>{icon2}</div>
                ))}

            {text && (
                <div
                    className={"text-container"}
                    onClick={() => {
                        if (onTextClick) {
                            onTextClick();
                        }
                    }}
                >
                    <p>{text}</p>
                </div>
            )}

            {iconRight && <div className={"icon-container"}>{iconRight}</div>}
        </>
    );

    return (
        <div
            data-testid="icon"
            className={`icon-text ${hoverable ? "hoverable" : ""} ${disabled ? "disabled" : ""}`}
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
        >
            {link ? (
                <Link className={"custom-link"} to={link}>
                    {content}
                    <NavigateNextIcon />
                </Link>
            ) : (
                content
            )}
        </div>
    );
}

export default IconText;
